import { Form, Input } from 'antd';
import React from 'react';
import { FormInstance } from 'antd/lib/form/Form';
import styled from 'styled-components';
import { TTenants } from './type';
import {
    EInvoiceInput,
    EInvoiceInputPassword,
} from '../../components/form/input';
import { EInvoiceForm } from '../../components/form/form';
import { useCopyToClipboard } from '../../hooks/useCopyToClipboard';
import { ICCopy } from '../../icons';
import { useNotification } from '../../hooks/useNotification';

const Wrapper = styled.div`
    .ant-form-item-has-error {
        .ant-row {
            align-items: flex-start;
        }
    }
    .copy-input {
        input,
        .ant-input-group-addon,
        .track-input-control {
            cursor: pointer !important;
            opacity: 1 !important;
            pointer-events: auto !important;
        }
    }
`;

type TenantFormProps = {
    tenantData: TTenants | undefined;
    form: FormInstance;
};
export const TenantForm: React.FC<TenantFormProps> = ({ tenantData, form }) => {
    const { copy } = useCopyToClipboard();
    const { showSuccess } = useNotification();
    const [webhookOperaUrl, setWebhookOperaUrl] = React.useState<string>('');
    const [webhookPosUrl, setWebhookPosUrl] = React.useState<string>('');

    const handleCopy = React.useCallback(
        (fieldForm: string) => {
            const value = form.getFieldValue(fieldForm);
            if (!value) {
                return;
            }
            copy(value);
            showSuccess('Copied to clipboard');
        },
        [form, copy, showSuccess]
    );

    const childForm = (
        <div className="grid gap-[20px] grid-cols-[1fr]">
            <div className="grid grid-cols-2 gap-[15px]">
                <Form.Item
                    name="name"
                    label="Name"
                    rules={[
                        {
                            required: true,
                            message: 'Please input the Name!',
                        },
                    ]}
                >
                    <EInvoiceInput isRequired={true} />
                </Form.Item>
                <Form.Item
                    name="tin"
                    label="TIN"
                    rules={[
                        {
                            required: true,
                            message: 'Please input the TIN!',
                        },
                    ]}
                >
                    <EInvoiceInput isRequired={true} />
                </Form.Item>
            </div>
            <div className="grid grid-cols-2 gap-[15px]">
                <Form.Item
                    name="registration_no"
                    label="Registration No"
                    rules={[
                        {
                            required: true,
                            message: 'Please input the Registration No!',
                        },
                    ]}
                >
                    <EInvoiceInput isRequired={true} />
                </Form.Item>
                <Form.Item
                    name="sst_registration_no_id"
                    label="SST Registration No"
                    rules={[
                        {
                            required: true,
                            message: 'Please input the SST Registration No!',
                        },
                    ]}
                >
                    <EInvoiceInput isRequired={true} />
                </Form.Item>
            </div>
            <div className="grid grid-cols-2 gap-[15px]">
                <Form.Item
                    name="sst_registration_no_type"
                    label="SST Registration No Type"
                    rules={[
                        {
                            required: true,
                            message:
                                'Please input the SST Registration No Type!',
                        },
                    ]}
                >
                    <EInvoiceInput isRequired={true} />
                </Form.Item>
                <Form.Item
                    name="tourism_tax_no"
                    label="Tourism Tax No"
                    rules={[
                        {
                            required: true,
                            message: 'Please input the Tourism Tax No!',
                        },
                    ]}
                >
                    <EInvoiceInput isRequired={true} />
                </Form.Item>
            </div>
            <div className="grid grid-cols-2 gap-[15px]">
                <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                        {
                            required: true,
                            message: 'Please input the Email!',
                        },
                        {
                            type: 'email',
                            message: 'Please input valid email!',
                        },
                    ]}
                >
                    <EInvoiceInput isRequired={true} />
                </Form.Item>
                <Form.Item
                    name="msic"
                    label="MSIC"
                    rules={[
                        {
                            required: true,
                            message: 'Please input the MSIC!',
                        },
                    ]}
                >
                    <EInvoiceInput isRequired={true} />
                </Form.Item>
            </div>
            <div className="grid grid-cols-2 gap-[15px]">
                <Form.Item
                    name="phone"
                    label="Phone"
                    rules={[
                        {
                            required: true,
                            message: 'Please input the Phone!',
                        },
                    ]}
                >
                    <EInvoiceInput isRequired={true} />
                </Form.Item>
                <Form.Item
                    name="api_key"
                    label="API Key"
                    rules={[
                        {
                            required: true,
                            message: 'Please input the API Key!',
                        },
                    ]}
                >
                    <EInvoiceInput
                        size="large"
                        isRequired={true}
                        addonAfter={
                            <div
                                className="cursor-pointer"
                                onClick={() => {
                                    handleCopy('api_key');
                                }}
                            >
                                <ICCopy width={18} height={18} />
                            </div>
                        }
                    />
                </Form.Item>
            </div>
            <div className="grid grid-cols-2 gap-[15px]">
                <Form.Item
                    name="webhook_opera_url"
                    label="Webhook Opera URL"
                    className="copy-input"
                >
                    <div
                        className="cursor-pointer w-full"
                        onClick={() => {
                            handleCopy('webhook_opera_url');
                        }}
                    >
                        <EInvoiceInput
                            disabled
                            size="large"
                            value={webhookOperaUrl}
                            style={{
                                padding: 0,
                            }}
                            addonAfter={<ICCopy width={18} height={18} />}
                        />
                    </div>
                </Form.Item>
                <Form.Item
                    name="webhook_pos_url"
                    label="Webhook POS URL"
                    className="copy-input"
                >
                    <div
                        className="cursor-pointer w-full"
                        onClick={() => {
                            handleCopy('webhook_pos_url');
                        }}
                    >
                        <EInvoiceInput
                            disabled
                            size="large"
                            value={webhookPosUrl}
                            style={{
                                padding: 0,
                            }}
                            addonAfter={<ICCopy width={18} height={18} />}
                        />
                    </div>
                </Form.Item>
            </div>
            <div className="flex w-full">
                <Form.Item
                    name="description"
                    label="Description"
                    style={{ width: '100%' }}
                    rules={[
                        {
                            required: true,
                            message: 'Please input the Description!',
                        },
                    ]}
                >
                    <Input.TextArea
                        style={{ width: '100%' }}
                        required
                        rows={4}
                    />
                </Form.Item>
            </div>
            <div className="flex w-full flex-col">
                <div className="flex border border-gray-300 rounded-md">
                    <div className="w-full flex gap-3 flex-col p-[10px]">
                        <div className="text-md font-semibold">Address</div>
                        <div className="grid grid-cols-2 gap-[15px]">
                            <Form.Item
                                name="line0"
                                label="Address line 0"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please input the Address line 0!',
                                    },
                                ]}
                            >
                                <EInvoiceInput isRequired={true} />
                            </Form.Item>
                            <Form.Item
                                name="line1"
                                label="Address line 1"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please input the Address line 1!',
                                    },
                                ]}
                            >
                                <EInvoiceInput isRequired={true} />
                            </Form.Item>
                        </div>
                        <div className="grid grid-cols-2 gap-[15px]">
                            <Form.Item
                                name="line2"
                                label="Address line 2"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please input the Address line 2!',
                                    },
                                ]}
                            >
                                <EInvoiceInput isRequired={true} />
                            </Form.Item>
                            <Form.Item
                                name="postal"
                                label="Address Postal"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please input the Address Postal!',
                                    },
                                ]}
                            >
                                <EInvoiceInput isRequired={true} />
                            </Form.Item>
                        </div>
                        <div className="grid grid-cols-2 gap-[15px]">
                            <Form.Item
                                name="city"
                                label="Address City"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please input the Address City!',
                                    },
                                ]}
                            >
                                <EInvoiceInput isRequired={true} />
                            </Form.Item>
                            <Form.Item
                                name="state"
                                label="Address State"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please input the Address State!',
                                    },
                                ]}
                            >
                                <EInvoiceInput isRequired={true} />
                            </Form.Item>
                        </div>
                        <div className="grid grid-cols-1 gap-[15px]">
                            <Form.Item
                                name="country"
                                label="Address Country"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please input the Address Country!',
                                    },
                                ]}
                            >
                                <EInvoiceInput isRequired={true} />
                            </Form.Item>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex w-full flex-col">
                <div className="flex border border-gray-300 rounded-md">
                    <div className="w-full flex gap-3 flex-col p-[10px]">
                        <div className="text-md font-semibold">
                            Invoice API Settings
                        </div>
                        <div className="grid grid-cols-2 gap-[15px]">
                            <Form.Item
                                name="api_url"
                                label="API URL"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input the API URL!',
                                    },
                                ]}
                            >
                                <EInvoiceInput isRequired={true} />
                            </Form.Item>
                            <Form.Item
                                name="username"
                                label="Username"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input the Username!',
                                    },
                                ]}
                            >
                                <EInvoiceInput isRequired={true} />
                            </Form.Item>
                        </div>
                        <div className="grid grid-cols-2 gap-[15px]">
                            <Form.Item
                                name="password"
                                label="Password"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input the Password!',
                                    },
                                ]}
                            >
                                <EInvoiceInputPassword isRequired={true} />
                            </Form.Item>
                            <Form.Item
                                name="invoice_api_settings_api_key"
                                label="API Key"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input the API Key!',
                                    },
                                ]}
                            >
                                <EInvoiceInput isRequired={true} />
                            </Form.Item>
                        </div>
                        <div className="grid grid-cols-2 gap-[15px]">
                            <Form.Item
                                name="api_signature"
                                label="API Signature"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please input the API Signature!',
                                    },
                                ]}
                            >
                                <EInvoiceInput isRequired={true} />
                            </Form.Item>
                            <Form.Item
                                name="api_signature"
                                label="API Signature"
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            'Please input the API Signature!',
                                    },
                                ]}
                            >
                                <EInvoiceInput isRequired={true} />
                            </Form.Item>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    React.useEffect(() => {
        if (tenantData) {
            form.setFieldsValue({
                name: tenantData.name,
                tin: tenantData.tin,
                registration_no: tenantData.registration_no,
                sst_registration_no_id: tenantData.sst_registration_no_id,
                sst_registration_no_type: tenantData.sst_registration_no_type,
                tourism_tax_no: tenantData.tourism_tax_no,
                email: tenantData.email,
                msic: tenantData.msic,
                phone: tenantData.phone,
                api_key: tenantData.api_key,
                description: tenantData.description,
                line0: tenantData.address.line0,
                line1: tenantData.address.line1,
                line2: tenantData.address.line2,
                postal: tenantData.address.postal,
                city: tenantData.address.city,
                state: tenantData.address.state,
                country: tenantData.address.country,
                api_url: tenantData.invoice_api_settings.api_url,
                username: tenantData.invoice_api_settings.username,
                password: tenantData.invoice_api_settings.password,
                invoice_api_settings_api_key:
                    tenantData.invoice_api_settings.api_key,
                api_signature: tenantData.invoice_api_settings.api_signature,
                webhook_opera_url: tenantData.webhook_opera_url,
                webhook_pos_url: tenantData.webhook_pos_url,
            });
            setWebhookOperaUrl(tenantData.webhook_opera_url || '');
            setWebhookPosUrl(tenantData.webhook_pos_url || '');
        }
    }, [tenantData, form]);

    return (
        <Wrapper className="flex flex-col gap-[20px] w-full overflow-hidden h-full items-start box-border py-[20px] px-[5px]">
            <EInvoiceForm
                form={form}
                labelWrap
                layout="vertical"
                className="w-full"
                name="createUser"
                childNode={childForm}
            />
        </Wrapper>
    );
};
